import { MapPin, Phone, Mail, MessageCircle } from "lucide-react";
import { WHATSAPP_NUMBER } from "../data";

export default function Footer() {
    return (
        <footer id="contato" data-testid="footer-section" className="bg-emerald-950 text-stone-200 relative grain">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-4">
                            <img src="/images/logo.jpg" alt="Chalés Boutique da Serra" className="h-16 w-16 rounded-full object-cover" />
                            <div>
                                <p className="font-black tracking-tight text-xl text-stone-50">Chalés Boutique da Serra</p>
                                <p className="text-xs uppercase tracking-[0.25em] text-emerald-300 mt-1">Natureza · Descanso · Afeto</p>
                            </div>
                        </div>
                        <p className="mt-6 text-stone-400 text-sm leading-relaxed max-w-sm">
                            Dois chalés boutique na Serra da Moeda, com café da manhã e jantar inclusos, piscina spa aquecida e vista que abraça.
                        </p>
                    </div>
                    <div className="md:col-span-4 space-y-5 text-sm">
                        <p className="text-xs font-bold uppercase tracking-[0.25em] text-emerald-300">Onde estamos</p>
                        <p className="flex items-start gap-3 text-stone-300">
                            <MapPin size={18} className="shrink-0 mt-0.5 text-emerald-400" />
                            Estrada Sentido Marinho da Serra — Moeda, MG, 35470-000
                        </p>
                        <p className="text-stone-400">Check-in a partir das 12h · Check-out até as 16h</p>
                    </div>
                    <div className="md:col-span-3 space-y-5 text-sm">
                        <p className="text-xs font-bold uppercase tracking-[0.25em] text-emerald-300">Fale conosco</p>
                        <a
                            data-testid="footer-phone-link"
                            href={`https://wa.me/${WHATSAPP_NUMBER}`}
                            target="_blank"
                            rel="noreferrer"
                            className="flex items-center gap-3 text-stone-300 hover:text-stone-50 transition-colors"
                        >
                            <Phone size={18} className="text-emerald-400" /> 31 93300-4813
                        </a>
                        <a
                            data-testid="footer-email-link"
                            href="mailto:admboutiquecabanas@gmail.com"
                            className="flex items-center gap-3 text-stone-300 hover:text-stone-50 transition-colors break-all"
                        >
                            <Mail size={18} className="shrink-0 text-emerald-400" /> admboutiquecabanas@gmail.com
                        </a>
                        <a
                            data-testid="footer-whatsapp-button"
                            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Olá! Quero saber mais sobre os Chalés Boutique da Serra.")}`}
                            target="_blank"
                            rel="noreferrer"
                            className="inline-flex items-center gap-2 bg-[#25D366] text-white text-xs font-bold uppercase tracking-widest px-6 py-4 hover:brightness-95 transition mt-2"
                        >
                            <MessageCircle size={16} /> Chamar no WhatsApp
                        </a>
                    </div>
                </div>
                <div className="mt-16 pt-8 border-t border-emerald-900 flex flex-col sm:flex-row justify-between gap-4 text-xs text-stone-500">
                    <p>© {new Date().getFullYear()} Chalés Boutique da Serra. Todos os direitos reservados.</p>
                    <p>Pet friendly · Café da manhã e jantar inclusos</p>
                </div>
            </div>

            <a
                data-testid="floating-whatsapp-button"
                href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Olá! Quero fazer uma reserva nos Chalés Boutique da Serra.")}`}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
                className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300"
            >
                <MessageCircle size={26} />
            </a>
        </footer>
    );
}
